    <div mat-dialog-title class="d-flex justify-content-between align-items-center">
      <h2 class="m-0">Salary details</h2>
      <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-dialog-content>
     <div class="slary_details_openrt">
  <!--  -->
  <div class="bookinght_sectiokl">
    <div class="salary_details_open">
       <div class="row">
      <div class="col-md-12 col-lg-6">
            <div class="sub_one sub_margin lg_line">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> schedule </span>
                </div>
                <div class="entity_detail make_text_grey">
                  Pay Type	
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.data.payType1 | titlecase}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="sub_one sub_margin">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> payments </span>
                </div>
                <div class="entity_detail make_text_grey">
                  Pay rate	
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.data.e_amount}}
                </div>
              </div>
            </div>
          </div>
          </div>
          </div>

 <div class="salary_details_open">
   <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="sub_one sub_margin lg_line">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> payments </span>
                </div>
                <div class="entity_detail make_text_grey">
                  Paid On	
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.data.paidOn1 | titlecase}}
                </div>
              </div>
            </div>
          </div>
          
          <div class="col-md-12 col-lg-6">
            <div class="sub_one sub_margin">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> receipt_long </span>
                </div>
                <div class="entity_detail make_text_grey">
                  Working Days	
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.data.workingDays}}
                </div>
              </div>
            </div>
          </div>
</div>
</div>
 <div class="salary_details_open">
  <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="sub_one sub_margin lg_line">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> receipt_long </span>
                </div>
                <div class="entity_detail make_text_grey">
                  Paid Leave	
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.data.paidLeave}}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 col-lg-6">
            <div class="sub_one sub_margin">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> receipt_long </span>
                </div>
                <div class="entity_detail make_text_grey">
                  Unpaid Leave	
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.data.unPaidLeave}}
                </div>
              </div>
            </div>
          </div>
</div>

</div>
          <div class="salary_details_open">
  <div class="row">
        <div class="col-md-12 col-lg-6">
            <div class="sub_one sub_margin lg_line">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> payments </span>
                </div>
                <div class="entity_detail make_text_grey">
                  Gross Payment	
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.data.e_netPayment}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="sub_one sub_margin">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> list_alt </span>
                </div>
                <div class="entity_detail make_text_grey">
                  Other Perks	
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.data.e_otherPerks}}
                </div>
              </div>
            </div>
          </div>
          </div>
          </div>
            <div class="salary_details_open">
           <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="sub_one sub_margin lg_line">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> list_alt </span>
                </div>
                <div class="entity_detail make_text_grey">
                  Perks Type	
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.data.perks_type ? parentdata.data.perks_type : '---'}}
                </div>
              </div>
            </div>
          </div>
           <div class="col-md-12 col-lg-6">
            <div class="sub_one sub_margin">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> menu </span>
                </div>
                <div class="entity_detail make_text_grey">
                  Deduction	
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.data.e_deduction}}
                </div>
              </div>
            </div>
          </div>
         </div>
         </div>
           <div class="salary_details_open">
           <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="sub_one sub_margin lg_line">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> menu </span>
                </div>
                <div class="entity_detail make_text_grey">
                  Deduction	Type
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.data.deduction_type ? parentdata.data.deduction_type : '---'}}
                </div>
              </div>
            </div>
          </div>
          
 <div class="col-md-12 col-lg-6">
            <div class="sub_one sub_margin">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> payments </span>
                </div>
                <div class="entity_detail make_text_grey">
                  Net pay	
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.data.currency_symbol}}{{+parentdata.data.netPayment + +parentdata.data.otherPerks - +parentdata.data.deduction}}
                </div>
              </div>
            </div>
          </div>
          </div>
</div>
    <div class="salary_details_open">
           <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="sub_one sub_margin lg_line">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> payments </span>
                </div>
                <div class="entity_detail make_text_grey">
                  Salary Type	
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.data.salaryType1 | titlecase}}
                </div>
              </div>
            </div>
          </div>
          
  <div class="col-md-12 col-lg-6">
            <div class="sub_one sub_margin">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> list </span>
                </div>
                <div class="entity_detail make_text_grey">
                  Salary For	
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.data.paid_for}} 

                </div>
              </div>
            </div>
          </div>
</div>
</div>
   <div class="salary_details_open">
  <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="sub_one sub_margin lg_line">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> calendar_month </span>
                </div>
                <div class="entity_detail make_text_grey">
                  Salary Dispense Date	
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.data.salaryCreditDate | date}}
                </div>
              </div>
            </div>
          </div>
        
<div class="col-md-12 col-lg-6">
            <div class="sub_one sub_margin">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> description </span>
                </div>
                <div class="entity_detail make_text_grey">
                  Notes
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.data.notes && parentdata.data.notes != 'null' && parentdata.data.notes != '' ? (parentdata.data.notes | titlecase) : '---'}}
                </div>
              </div>
            </div>
          </div>
          </div>
          </div>
    </div>
</div>

    
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      (click)="generatePaySlip()"
      mat-flat-button
      color="accent"
      
    >
    Download pay-slip
    </button>
  </mat-dialog-actions>
  